// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Popover-cls1___8d4a44270197f08dd3f{/*!*/}.Popover-cls2___761f255b9109eb1906b{}.Popover-cls2___761f255b9109eb1906b.Popover-inline___3465415a4ce588d0c16{display:inline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Popover-cls1___8d4a44270197f08dd3f",
	"cls2": "Popover-cls2___761f255b9109eb1906b Popover-cls1___8d4a44270197f08dd3f",
	"inline": "Popover-inline___3465415a4ce588d0c16"
};
export default ___CSS_LOADER_EXPORT___;
